import { useState, useEffect } from 'react';
import apiService from '../../../../services/apiService';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballStates = () => {
  const { siteSettings } = useTenant();
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);

  // Static/Default data - shown when no dynamic data exists
  const staticStates = [
    {
      id: 1,
      state: 'Andhra Pradesh',
      president: { name: 'Sh. T. Munali Krishna Raju', email: 'eda.sulochana@gmail.com' },
      secretary: { name: 'MS Sulochana E', address: 'HO-23/1-4, Pragthi Nagar Road, Krishna District, AP', email: 'eda.sulochana@gmail.com' }
    },
    {
      id: 2,
      state: 'Andaman & Nicobar Island',
      president: { name: 'M R Saha', address: 'Port Blair, A&N Island', email: 'statesportsan@rediffmail.com' },
      secretary: { name: 'M A Manoharan', address: 'South Andaman', email: 'statesportsan@rediffmail.com' }
    },
    {
      id: 3,
      state: 'Bihar',
      president: { name: 'S.B Prashad', address: 'Gandhi Maidan, Patna', phone: '09334172298' },
      secretary: { name: 'Niraj Kumar "Pappu"', address: 'Patna', phone: '09431421908', email: 'biharthrowball@rediffmail.com' }
    },
    {
      id: 4,
      state: 'Gujarat',
      president: { name: 'Dr. Ramesh Patel', address: 'Ahmedabad', phone: '09876543210' },
      secretary: { name: 'Amit Shah', address: 'Gandhinagar', email: 'gujaratthrowball@gmail.com' }
    },
    {
      id: 5,
      state: 'Haryana',
      president: { name: 'Col. Rajinder Singh', address: 'Rohtak', phone: '09812345678' },
      secretary: { name: 'Suresh Kumar', address: 'Jind', email: 'haryanathrowball@gmail.com' }
    },
  ];

  useEffect(() => {
    fetchStates();
  }, []);

  const fetchStates = async () => {
    try {
      setLoading(true);
      const response = await apiService.get('/public/affiliates');
      const data = response.data;

      if (data.success && data.data && data.data.length > 0) {
        // Map API data to expected format
        const mappedStates = data.data.map((affiliate) => ({
          id: affiliate.id,
          state: affiliate.state || affiliate.association_name,
          president: {
            name: affiliate.president || '-',
            address: affiliate.address || '',
            email: affiliate.email || ''
          },
          secretary: {
            name: affiliate.secretary || '-',
            address: affiliate.address || '',
            phone: affiliate.contact || '',
            email: affiliate.email || ''
          }
        }));
        setStates(mappedStates);
      } else {
        setStates(staticStates);
      }
    } catch (error) {
      console.error('Error fetching states:', error);
      setStates(staticStates);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="tb-page-section tb-states-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.states || '/theme/assets/images/banner-3.jpg'} alt="States Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content">
          <div className="tb-heading-top">
            <h1 className="tb-page-title">States</h1>
            <span className="tb-mini-line"></span>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Loading...</p>
            </div>
          ) : (
            <div className="tb-table-wrapper">
              <table className="tb-info-table">
                <thead style={{ background: '#3f75b1', color: '#fff' }}>
                  <tr>
                    <th className="tb-col-serial" style={{ background: '#3f75b1', color: '#fff' }}>S.No</th>
                    <th style={{ background: '#3f75b1', color: '#fff' }}>State</th>
                    <th style={{ background: '#3f75b1', color: '#fff' }}>President</th>
                    <th style={{ background: '#3f75b1', color: '#fff' }}>Secretary</th>
                  </tr>
                </thead>
                <tbody>
                  {states.map((item, index) => (
                    <tr key={item.id || index}>
                      <td className="tb-col-serial">{index + 1}</td>
                      <td>{item.state}</td>
                      <td>
                        <strong>{item.president.name}</strong>
                        {item.president.address && <><br />{item.president.address}</>}
                        {item.president.phone && <><br />Ph: <a href={`tel:${item.president.phone}`} className="tb-info-link">{item.president.phone}</a></>}
                        {item.president.email && <><br />Email: <a href={`mailto:${item.president.email}`} className="tb-info-link">{item.president.email}</a></>}
                      </td>
                      <td>
                        <strong>{item.secretary.name}</strong>
                        {item.secretary.address && <><br />{item.secretary.address}</>}
                        {item.secretary.phone && <><br />Mob: <a href={`tel:${item.secretary.phone}`} className="tb-info-link">{item.secretary.phone}</a></>}
                        {item.secretary.email && <><br />Email: <a href={`mailto:${item.secretary.email}`} className="tb-info-link">{item.secretary.email}</a></>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ThrowballStates;
